// removed by extract-text-webpack-plugin
module.exports = {"PopupContent":"RegionPopup__PopupContent___KQNMT","PopupTitle":"RegionPopup__PopupTitle___3L-zR","PopupBody":"RegionPopup__PopupBody___3arxi","RegionItem":"RegionPopup__RegionItem___CIdYC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Region/RegionPopup/RegionPopup.scss
// module id = 1420
// module chunks = 0